export class CopyButton {
  constructor() {
    this.init = this.init.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.init();
  }

  init() {
    this.copyLinkBtn = document.querySelector('[data-id="copy-link-btn"]');

    if (this.copyLinkBtn) {
      this.copyLinkBtn.addEventListener('click', this.handleClick);
    }
  }

  handleClick() {
    const textToCopy = this.copyLinkBtn.dataset.url;

    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).catch(() => {
        // catch failed copies
      });
    }
  }
}
export default CopyButton;
